import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from './controls/button/button.component';
import { CommonModule, DatePipe } from '@angular/common';
import { CalendarComponent } from './controls/calendar/calendar.component';
import { PopupComponent } from './popup/popup.component';
import { DatepickerComponent } from './controls/datepicker/datepicker.component';
import { FormControlErrorComponent } from './controls/form-control-error/form-control-error.component';
import { MonthPipe } from './pipes/month.pipe';
import { WeekdayPipe } from './pipes/weekday.pipe';
import { TimePipe } from './pipes/time.pipe';
import { MultiDatepickerComponent } from './controls/datepicker/multi-datepicker.component';
import { MenuComponent } from './controls/menu/menu.component';
import { DropdownComponent } from './controls/dropdown/dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  declarations: [
    ButtonComponent,
    CalendarComponent,
    PopupComponent,
    DatepickerComponent,
    FormControlErrorComponent,
    MonthPipe,
    WeekdayPipe,
    TimePipe,
    MultiDatepickerComponent,
    DropdownComponent,
    MenuComponent
  ],
  providers: [
    DatePipe
  ], 
  exports: [
    ButtonComponent,
    CalendarComponent,
    PopupComponent,
    DatepickerComponent,
    FormControlErrorComponent,
    MonthPipe,
    WeekdayPipe,
    TimePipe,
    MultiDatepickerComponent,
    DropdownComponent,
    MenuComponent
  ]
})
export class MdSitesLibModule { }
